import React, { useId } from "react";
import { twMerge } from "tailwind-merge";

export interface LgvCheckboxFieldProps {
  id?: string;
  name?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  className?: string;
}

const LgvCheckboxField: React.FC<LgvCheckboxFieldProps> = ({
  id,
  name,
  checked,
  onChange,
  label,
  disabled = false,
  className,
}) => {
  const generatedId = useId();
  const fieldId = id ?? generatedId;

  return (
    <label
      htmlFor={fieldId}
      className={twMerge(
        "block cursor-pointer rounded-lg border p-3 transition-colors",
        checked
          ? "border-[#1B365D] bg-[#EFF6FF] shadow-[0_0_0_1px_rgba(27,54,93,0.08)]"
          : "border-gray-200 bg-white hover:border-[#1B365D]/35 hover:bg-slate-50",
        disabled && "cursor-not-allowed opacity-50 hover:bg-white hover:border-gray-200",
        className,
      )}
    >
      <input
        type="checkbox"
        id={fieldId}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        className="sr-only"
      />
      <span
        className={twMerge(
          "text-base text-[#1B365D]",
          checked && "font-medium",
        )}
      >
        {label}
      </span>
    </label>
  );
};

export default LgvCheckboxField;
